import { ISelectOption } from 'components/common/Select/types';
import dayjs from 'dayjs';
import { useIntl } from 'react-intl';

export const useDatesOptions = () => {
  const intl = useIntl();

  const generateMonthOptions = (): ISelectOption[] => {
    return [
      { label: intl.formatMessage({ id: 'month.january' }), value: 'January' },
      { label: intl.formatMessage({ id: 'month.february' }), value: 'February' },
      { label: intl.formatMessage({ id: 'month.march' }), value: 'March' },
      { label: intl.formatMessage({ id: 'month.april' }), value: 'April' },
      { label: intl.formatMessage({ id: 'month.may' }), value: 'May' },
      { label: intl.formatMessage({ id: 'month.june' }), value: 'June' },
      { label: intl.formatMessage({ id: 'month.july' }), value: 'July' },
      { label: intl.formatMessage({ id: 'month.august' }), value: 'August' },
      { label: intl.formatMessage({ id: 'month.september' }), value: 'September' },
      { label: intl.formatMessage({ id: 'month.october' }), value: 'October' },
      { label: intl.formatMessage({ id: 'month.november' }), value: 'November' },
      { label: intl.formatMessage({ id: 'month.december' }), value: 'December' },
    ];
  };

  const generateDaysOptions = (): ISelectOption[] => {
    const daysOptions: ISelectOption[] = [];
    for (let i = 1; i <= 31; i++) {
      daysOptions.push({ label: String(i), value: String(i) });
    }
    return daysOptions;
  };

  const generateLastXYearsOptions = (years = 100): ISelectOption[] => {
    const yearsOptions: ISelectOption[] = [];
    for (let i = 0; i <= years; i++) {
      const year = dayjs().subtract(i, 'year').get('year');
      yearsOptions.push({ label: String(year), value: String(year) });
    }
    return yearsOptions;
  };

  const generateRetirentAgeRange = () => {
    const yearsOptions: ISelectOption[] = [];
    for (let i = 75; i >= 40; i--) {
      yearsOptions.push({ label: `${i}`, value: `${i}` });
    }
    return yearsOptions;
  };

  const monthOptions = generateMonthOptions();
  const daysOptions = generateDaysOptions();
  const retirentAgeRange = generateRetirentAgeRange();

  return {
    daysOptions,
    monthOptions,
    retirentAgeRange,
    generateLastXYearsOptions,
  };
};
